import { render } from "./ReviewReports.vue?vue&type=template&id=74c8af7c"
import script from "./ReviewReports.vue?vue&type=script&lang=js"
export * from "./ReviewReports.vue?vue&type=script&lang=js"

import "./ReviewReports.vue?vue&type=style&index=0&id=74c8af7c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__